(function(){
  function formatMoney(cents, currency){
    // Shopify has a global formatMoney if theme provides; try it first.
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.money_format || '{{amount}}');
      }
    } catch(e){}
    // Fallback simple GBP formatter
    try {
      return new Intl.NumberFormat(undefined, { style:'currency', currency: (currency || 'GBP') }).format((cents||0)/100);
    } catch(e){
      return '£' + ((cents||0)/100).toFixed(2);
    }
  }

  function getVariantData(productId){
    var el = document.getElementById('tdj-variants-' + productId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e){ return null; }
  }

  function updatePrice(variant, priceEl){
    if (!variant || !priceEl) return;
    var amountEl = document.getElementById('tdj-price-amount');
    var text = formatMoney(variant.price, variant.currency_code || 'GBP');
    (amountEl || priceEl).textContent = text;
  }

  function bind(productId){
    var priceWrap = document.getElementById('tdj-price');
    if (!priceWrap) return;
    var variants = getVariantData(productId) || [];
    var byId = {}; variants.forEach(v=>{byId[v.id]=v});

    function handleVariantId(id){
      var v = byId[id];
      if (v) updatePrice(v, priceWrap);
    }

    // 1) Listen to Shopify's variant:change event (Online Store 2.0 standard)
    document.addEventListener('variant:change', function(e){
      try{
        var v = e.detail && e.detail.variant;
        if (v && String(v.product_id) === String(productId)) {
          updatePrice(v, priceWrap);
        }
      }catch(_){}
    });

    // 2) Fallback: watch change on selects inside the product form
    var form = priceWrap.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('change', function(){
        var vidInput = form.querySelector('input[name="id"], select[name="id"]');
        var vid = vidInput && (vidInput.value || vidInput.options && vidInput.options[vidInput.selectedIndex].value);
        if (vid) handleVariantId(vid);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    var wrap = document.getElementById('tdj-price');
    if (!wrap) return;
    var productId = wrap.getAttribute('data-product-id');
    bind(productId);
  });
})();
